// Config/endpoints.js
export const ENDPOINTS = {
  Despacho: 'ListarDespacho',
  Vehiculo: 'ListarVehiculo',
  Ruta: 'ListarRuta',
  Autorizaciones: 'ListarAutorizaciones',
  Conductores: 'ListarConductores',
  Novedades: 'ListarNovedades',
  Llegadas: 'ListarLlegadas',
  NovedadesConductor: 'ListarNovedadesConductor',
  NovedadesVehiculo: 'ListarNovedadesVehiculo',
  LlegadasVehiculo: 'ListarLlegadasVehiculo',
  LlegadasConductor: 'ListarLlegadasConductor'
};